import styled from 'styled-components';
import {Box} from "@mui/material";
import {semanticColors} from "../../../../../theme/tokens/tokens";

export const NoCategoryIconBox = styled(Box)`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: ${semanticColors.orange.light.bg};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg {
        font-size: 32px;
        color: ${semanticColors.orange.light.fg};
    }
`;